import React from "react";

export const LinkCell = ({ value }) =>
  value ? (
    <a href={value} target="_blank" rel="noopener noreferrer">
      {value}
    </a>
  ) : null;
